var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { initializeAdyenPaymentMethod } from "../psp/adyen/client.mjs";
import { objectEntries } from "../utils.mjs";
import { elementInstance } from "./instance.mjs";
import { initializeStripeIfNeeded } from "./stripe/index.mjs";
export const initializeCheckoutElements = (state, actions) => __awaiter(void 0, void 0, void 0, function* () {
    state.onChange((newState, oldState) => {
        const checkoutPagePayment = getCheckoutPagePayment(newState);
        if (checkoutPagePayment) {
            initializePaymentMethodIfNeeded({ newState, oldState, checkoutPagePayment, state, actions });
        }
        else {
            uninitializeAll();
        }
        initializeStripeIfNeeded(state, actions);
    });
});
const initializePaymentMethodIfNeeded = (_a) => __awaiter(void 0, [_a], void 0, function* ({ newState, oldState, checkoutPagePayment, state, actions, }) {
    const newPaymentMethod = selectedPaymentMethod(newState);
    const oldPaymentMethod = oldState ? selectedPaymentMethod(oldState) : undefined;
    // Apple Pay is a special case where we want to initilize it on every cart change to
    // ensure that the amount.value is always up to date with the current carts leftToPay amount
    // TODO: We might want to do the same for all payment methods to ensure that the amount is always up to date
    if ((newPaymentMethod === null || newPaymentMethod === void 0 ? void 0 : newPaymentMethod.id) === 'applepay') {
        initializePaymentMethod(newPaymentMethod.id, checkoutPagePayment, state, actions);
        return;
    }
    if ((newPaymentMethod === null || newPaymentMethod === void 0 ? void 0 : newPaymentMethod.id) === (oldPaymentMethod === null || oldPaymentMethod === void 0 ? void 0 : oldPaymentMethod.id)) {
        return;
    }
    if (!newPaymentMethod) {
        // This happens eg after a purchase has been completed because the selected
        // payment method is cleared from the cart.
        uninitializeAll();
        return;
    }
    initializePaymentMethod(newPaymentMethod.id, checkoutPagePayment, state, actions);
});
const paymentMethodUninitializers = {};
const initializePaymentMethod = (paymentMethodId, checkoutPagePayment, state, actions) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const paymentMethod = checkoutPagePayment.paymentMethods.find((method) => method.id === paymentMethodId);
    if (!paymentMethod) {
        throw new Error(`Could not find payment method with id ${paymentMethodId}`);
    }
    // We only want one payment method to be initialized at any given time so when a payment method is selected we need to
    // uninitialize the previous one
    uninitializeAll();
    if (paymentMethod.provider === 'adyen') {
        const showBuyButton = (_a = state.checkout) === null || _a === void 0 ? void 0 : _a.showBuyButton;
        const element = elementInstance({
            elementId: showBuyButton ? paymentMethod.elementId : state.checkoutElements.buyButtonElementId,
            idempotencyKey: paymentMethod.id,
            onMount: (e) => __awaiter(void 0, void 0, void 0, function* () {
                return yield initializeAdyenPaymentMethod(state, actions, paymentMethod, e);
            }),
        });
        paymentMethodUninitializers[paymentMethod.id] = () => element.destroy();
    }
});
const uninitializeAll = () => {
    for (const [key, uninitialize] of objectEntries(paymentMethodUninitializers)) {
        uninitialize();
        delete paymentMethodUninitializers[key];
    }
};
const getCheckoutPagePayment = (state) => { var _a, _b; return ((_b = (_a = state.checkout) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.$type) === 'checkoutPage' ? state.checkout.payment : undefined; };
const selectedPaymentMethod = (state) => { var _a, _b; return ((_b = (_a = state.checkout) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.$type) === 'checkoutPage' ? state.checkout.payment.selectedPaymentMethod : undefined; };
//# sourceMappingURL=index.js.map